import React, { FC, useEffect, useState } from 'react';
import {
  Text,
  VStack,
  useColorModeValue,
  HStack,
  Card,
  CardHeader,
  Avatar,
  Stack,
} from '@chakra-ui/react';
import { useFetch } from 'use-http';
import { useParams } from 'react-router';
import { api, makeHeaders } from '../../util/api';
import Loading from '../Misc/Loading';
import { ERROR_MESSAGE, useNotify } from '../../hooks/useNotify';
import EmptyContent from '../EmptyContent';
import { SurveyResponse } from '../Survey/types';
import { User } from '../../store/slices/User/reducer';
import SurveyResponseCard from '../Survey/SurveyResponseCard';
import TextLabel from '../Misc/LText';
import { UserRole, getUserTypeLabel } from '../../util/user';

const UserActivity: FC = () => {
  const notify = useNotify();
  const { id } = useParams();
  const [user, setuser] = useState<User | null>(null);
  const [responses, setResponses] = useState<SurveyResponse[]>([]);
  // TODO: filter by archived in the backend
  const filteredResponses = responses.filter((response) => !response.archived);

  const {
    error,
    cache,
    loading,
    response,
    get,
  } = useFetch(`${api}/users/${id}?details=true`, makeHeaders());
  const refreshSurveyResponses = async () => {
    try {
      cache.clear();
      const userDetails: User = await get();
      if (!error && response.ok && userDetails) {
        setuser(userDetails);
        const userResponses = userDetails.surveyResponses;
        if (userResponses) {
          setResponses(userResponses);
        }
      } else {
        throw new Error();
      }
    } catch {
      notify(ERROR_MESSAGE, 'error');
    }
  };

  useEffect(() => {
    refreshSurveyResponses();
  }, []); // eslint-disable-line

  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const fullName = `${user?.firstName} ${user?.lastName}`;

  return (
    <Stack maxW='container.lg'>

      <Card>
        <CardHeader>
          {<Loading isLoading={loading} />}
          {!loading && (
            <HStack justify='space-between'>
              <HStack justify='start'>
                <Avatar name={fullName} />
                <VStack gap={0} align='start'>
                  <TextLabel title={fullName} />
                  <Text fontSize='sm' fontWeight='semibold'>{getUserTypeLabel(user?.role as UserRole)}</Text>
                </VStack>
              </HStack>
            </HStack>
          )}
        </CardHeader>
      </Card>
      <>
        <Card
          variant='outline'
          p={4}
          borderColor={borderColor}
          bg={useColorModeValue('gray.50', 'gray.700')}
        >
          <TextLabel title='Respuestas registradas' />
          <Loading isLoading={loading} />
          {!filteredResponses.length && <EmptyContent title='No hay ninguna respuesta' />}
          {filteredResponses.map((surveyResponse) => (
            <SurveyResponseCard
              key={surveyResponse.id}
              survey={null}
              response={surveyResponse}
              disabled
              displayStatus
            />
          ))}
        </Card>
      </>
    </Stack>
  );
};

export default UserActivity;
